module.exports = __webpack_public_path__ + "static/media/analytics.7f63558f.svg";